import { useState} from "react";
import API from "../../services/API";
import Accept from "./Accept";
import Success from "./Success";
import Sign from "./Sign";
import Verify from "./Verify";
import {Stack, Typography, Divider} from "@mui/material";
import Loader from "../Tools/Loader";
import { useEffect } from "react";
import Authenticate from "./Authenticate";

/**
 * Signature process :
 * 1. Start the signature process (by clicking on a CTA). A signature is created in the database (status = created).
 * 2. The signer confirm that he is logged on his own account (status = authenticated).
 * 3. The signer declare that he has read the document and accept its content (status = accepted).
 * X. The signer received an email with a code to verify his identity (status = emailed).
 * X. The signer submit the verification code (status = verified). /!\ CANCELED
 * 4. The signer enter his name and activate a checkbox to sign the document (status = signed).
 */
export default function Signature({data, onSuccess}){

    const [item, setItem] = useState(data)

    const [status, setStatus] = useState('loading')

    const statusIs = s => s === status

    useEffect(() => {

        const status = data.signed ? 'success' : (data.id ? 'authenticate' : 'loading');

        setStatus(status)

        if(status === 'loading' ){

            API.post(`/signatures`, data)
                .then(r => {
                    setStatus(r.data.signed ? 'success' : 'authenticate')
                    setItem(r.data)
                })
        }

    }, [data])


    const handleAuthenticate = () => {

        setStatus('loading')

        API.put(`/signatures/${item.id}/authenticate`, item)
            .then(() => setStatus('accept'))
            .catch(() => setStatus('authenticate'))
    }


    const handleAccept = () => {

        setStatus('loading')

        API.put(`/signatures/${item.id}/accept`, item)
            .then(() => setStatus('sign'))
            .catch(() => setStatus('accept'))
    }


    const handleVerify = e => {
        e.preventDefault();
        
        setStatus('verifyLoading');

        API.put(`/signatures/${item.id}/verify`, item)
            .then(() => setStatus('sign'))
            .catch(() => setStatus('verifyError'))
    }


    const handleSign = e => {
        e.preventDefault();

        setStatus('signLoading');

        if(item.file){

            API.upload(`/signatures/${item.id}/upload`, item.file)
                .then(r => console.log(r.data))
                .catch(e => console.log(e.response?.data))
        }

        API.put(`/signatures/${item.id}/sign`, item)
            .then(() => handleSuccess())
            .catch(() => setStatus('sign'))
    }


    const handleSuccess = () => {
        setStatus('success')
        return !onSuccess ? false : onSuccess(item) 
    }


    return <Stack spacing={3} sx={{maxWidth: 800, margin: 'auto'}}>

        <Typography variant='h2'>{item.title}</Typography>

        <Divider />


        {statusIs('loading') && 
            <Loader />
        }


        {status.startsWith('authenticate') &&
            <Authenticate
                onClick={handleAuthenticate}
                data={item}
            />
        }


        {status.startsWith('accept') &&
            <Accept
                onClick={handleAccept}
                loading={statusIs('acceptLoading')}
                data={item}
            />
        }


        {status.startsWith('verify') &&
            <Verify
                data={item}
                onChange={item => setItem(item)}
                onSubmit={handleVerify}
                loading={statusIs('verifyLoading')}
                error={statusIs('verifyError')}
            />
        }


        {status.startsWith('sign') &&
            <Sign
                data={item}
                onChange={item => setItem(item)}
                onSubmit={handleSign}
                loading={statusIs('signLoading')}
            />
        }

        {statusIs('success') &&
            <Success data={item} />
        }


    </Stack>
}

